export default {
  saveOrders(state, orders) {
    state.orders = orders;
  },
};
